module.exports = fox._r("images/mobile.png", __webpack_public_path__ + "images/mobile.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/mobile.png
// module id = 1086
// module chunks = 4